function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8571 13.1429H12.1429V18.8571C12.1429 19.4857 11.6286 20 11 20C10.3714 20 9.85714 19.4857 9.85714 18.8571V13.1429H4.14286C3.51429 13.1429 3 12.6286 3 12C3 11.3714 3.51429 10.8571 4.14286 10.8571H9.85714V5.14286C9.85714 4.51429 10.3714 4 11 4C11.6286 4 12.1429 4.51429 12.1429 5.14286V10.8571H17.8571C18.4857 10.8571 19 11.3714 19 12C19 12.6286 18.4857 13.1429 17.8571 13.1429Z",
  fill: "#98989A"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 17,
  width: 3,
  height: 3,
  rx: 1.5,
  fill: "#98989A"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 19,
  y: 17,
  width: 3,
  height: 3,
  rx: 1.5,
  fill: "#98989A"
});

function SvgPlusEllipsis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusEllipsis);
export default __webpack_public_path__ + "static/media/plus-ellipsis.24f5c485.svg";
export { ForwardRef as ReactComponent };